import { Box, useMediaQuery } from "@material-ui/core";

interface GridContainerProps extends React.FC<{}> {}

const GridContainer: GridContainerProps = function (props) {
  const isSmall = useMediaQuery("(max-width:768px)");

  return (
    <Box
      style={{
        display: "grid",
        gridTemplateColumns: isSmall ? "1fr" : "1fr 1fr",
        gridColumnGap: "3rem",
        gridRowGap: isSmall ? "1rem" : "1.5rem",
        marginTop: "2rem",
      }}
    >
      {props.children}
    </Box>
  );
};

export default GridContainer;
